module.exports = __webpack_public_path__ + "img/block7-card1.929b8844.svg";